<template>
  <div class="bg">
    <el-button class='bacToIndex' size="mini" @click="backtoIndex">返回首页</el-button>
    <div class='topTitle'>园区企业</div>
    <!-- <div class='bigBox'>
      <img src="../../assets/arrowLeft.png" alt="" @click="toPre">
      <div class='bigContent'>
         <el-carousel height="80vh" arrow="never" ref='carousel'>
          <el-carousel-item  style="display: flex; align-items: center;">
            <div class='carContent'>
              <div class='content'>
                <img src="../../assets/img4.jpg" alt="">
                <h3>中国科学院计算技术研究所太仓分所</h3>
                <div>企业介绍：是由中国科学院计算技术研究所与太仓市人民政府共建的新型研发机构，主要围绕智能工业、工业大数据分析、智慧工厂以及数字文化装备等新兴产业进行关键技术研究开发及产业化。</div>
              </div>
              <div class='content2'>
                <img src="../../assets/img2.jpg" alt="">
                <h3>太仓光电技术研究所</h3>
                <div>企业介绍：是一家产学研联合创新载体，旨在落实中科院院地合作精神，以太仓市、苏州市及江苏省的经济和社会发展需求为导向，围绕光电信息、智能制造、先进医疗、物联网以及新材料等产业方向，开展技术转移、成果转化、自主研发及产业孵化工作。</div>            
              </div>
              <div class='content'>
                <img src="../../assets/img1.jpg" alt="">
                <h3>西北工业大学太仓长三角研究院</h3>
                <div>企业介绍：西北工业大学与江苏省太仓市签订协议开展市校合作，共同建设西北工业大学太仓长三角研究院。紧盯关键共性技术、前沿引领技术、现代工程技术、颠覆性技术，聚焦核能材料、人工智能、智能制造、民用航空等领域，开展科技成果研发、高新企业孵化、技术转移应用、创新人才培养等工作。</div>             
              </div>
            </div>           
          </el-carousel-item>
          <el-carousel-item  style="display: flex; width: 100%; align-items: center;">
            <div class='carContent'>
              <div class='content'>
                <img src="../../assets/img6.jpg" alt="">
                <h3>上海交大空天技术创新中心</h3>
                <div>企业介绍：太仓高新区与上海交大航空宇航学院、上海交大技术转移中心签约共建“上海交通大学航空航天学院-太仓高新区空天技术联合创新中心”，充分整合资源，促进地方高层次人才的引进、校企地联合科技创新与产业化，集聚百亿级空天产业群，推动太仓市空天产业发展。</div>
              </div>
              <div class='content2'>
                <img src="../../assets/img2.jpg" alt="">
                <h3>智能光电科创中心</h3>
                <div>企业介绍：由太仓高新区与太仓光电技术研究所合作建设，主要围绕光电传感器、光电信息获取、光电信息智能处理、光电系统应用、工业互联网及人工智能等产业，与国内外知名高校及国立研究机构建立稳定联系与合作，打造优秀双创人才集聚、高技术成果产业化集聚、协同创新与创业集聚的科技创新中心。</div>            
              </div>
              <div class='content'>
                <img src="../../assets/img6.jpg" alt="">
                <h3>上海交大空天技术创新中心</h3>
                <div>企业介绍：上海交通大学太仓空天技术创新中心于2021年始运营，中心建筑面积3000平方米，总计6层，一层为公共办公区，共有工位24个，其余楼层为独立办公区域，并配套独立多功能会议室。</div>             
              </div>
            </div>           
          </el-carousel-item>
          <el-carousel-item  style="display: flex; width: 100%; align-items: center;">
            <div class='carContent'>
              <div class='content'>
                <img src="../../assets/img5.jpg" alt="">
                <h3>中科智能科创中心</h3>
                <div>企业介绍：中科智能科创中心于2019年开始运营，专攻“人工智能、智能制造、高端装备、元宇宙”等领域。中心建筑面积3500平方米，已获评江苏省、苏州市级众创空间。拥有独立办公室15间、联合办公工位35个、多功能会议室3间、开放实验室1间。-太仓高新区空天技术联合创新中心”，充分整合资源，促进地方高层次人才的引进、校企地联合科技创新与产业化，集聚百亿级空天产业群，推动太仓市空天产业发展。</div>
              </div>
              <div class='content2'>
                <img src="../../assets/img3.jpg" alt="">
                <h3>智联部落众创空间</h3>
                <div>企业介绍：智联部落于2019年开始运营，专攻“人工智能、移动互联网+”等领域。建筑面积1072平方米，已获评苏州市级众创空间、江苏省级众创空间、江苏省女大学生就业创业实践基地和苏州健雄职业技术学院科普教育基地。工位数60个，独立办公间9个，配套多功能会议室1间。</div>            
              </div>
            </div>           
          </el-carousel-item>
        </el-carousel>
     </div>
      <img src="../../assets/arrowRight.png" alt="" @click="toNext">
    </div> -->
  </div>
</template>

<script>
export default {
  
  data() {
    return {
      list: [
        
      ],
    }
  },
  methods: {
    backtoIndex() {
      this.$router.push({ path: '/solution' })
    },
    toPre() {
      this.$refs.carousel.prev()
    },
    toNext() {
      this.$refs.carousel.next()
    },
  },
  created() {
  },
}
</script>

<style scoped lang='less'>
.bacToIndex {
  position: absolute;
  margin: 10px;
  left: 0;
  top: 0;
  background-color: #2655c9;
  color: #fff;
  font-weight: bold;
  border-radius: 8px;
}
.topTitle {
  text-align: center;
  color: #001e69;
  font-size: 50px;
  font-weight: bold;
}
.bigBox>img {
  cursor: pointer;
  width: 80px;
}
.bg {
  // min-width: 1600px;
  background-image: url('../../assets/busBack.jpg');
  height: 100vh;
  background-size: 100% 100%;
  background-position: center center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .bigBox {
    width: 85%;    
    height: 70vh;
    // border: 1px solid red;
    display: flex;
    overflow: hidden;
    // justify-content: center;
    align-items: center;
  }
  .bigContent {
    flex-grow: 1;
    flex-shrink: 1;
    // border: 1px solid green;
  }
  .carContent {
    display: flex;
    align-items: center;
    // border: 1px solid red;
    color: #fff;
    justify-content: center;
  }
  .content {
    box-sizing: border-box;
    padding: 30px;
    overflow: hidden;
    // flex-grow: 1;
    background-color: #0068b5;
    border-radius: 50px;
    // background-image: url('../../assets/boxBlue.jpg');
    height: 60vh;
    width: 33%;
    background-size: 100% 100%;
    img {
      width: 100%;
      height: 23vh;
    }
    div {
      font-size: 18px;;
    }
  }
  .content2 {
    overflow: hidden;
    box-sizing: border-box;
    padding: 30px;
    // flex-grow: 1;
    background-color: #2655c9;
    border-radius: 50px;
    // background-image: url('../../assets/boxYellow.jpg');
    height: 60vh;
    width: 33%;
    background-size: 100% 100%;
    margin: 0 30px;
     img {
      width: 100%;
      height: 23vh;
    }
    div {
      font-size: 18px;;
    }
  }
}
</style>

